// extracted by mini-css-extract-plugin
module.exports = {"list":"Grid_list__29PlW"};